module.exports = __webpack_public_path__ + "media/images/wave-bba5d534b5da8588a799bbb72c6a83c3.jpg";